export default __webpack_public_path__ + "static/media/safety-position-demo.1edd0542.png";